import PoweredByGiphyIcon from '@assets/icons/PoweredByGiphyIcon'
import { IGif } from '@giphy/js-types'
import { SearchContextManager } from '@giphy/react-components'
import { useTenantMetadata } from '@globals/useTenantMetadata'
import Box from '@mui/material/Box'
import { CustomDialog } from '@shared/dialog/CustomDialog'
import { FC } from 'react'
import GiphySearchContent from './GiphySearchContent'
import useGiphyDialog from './useGiphyDialog'

type GiphySearchDialogProps = {
  onGifSelected: (url: string) => void
  id: string
}
const GiphySearchDialog: FC<GiphySearchDialogProps> = ({ onGifSelected, id }) => {
  const [{ language }] = useTenantMetadata()

  const { closeGiphyDialog, giphyDialogKey, giphyApiKey } = useGiphyDialog(id)

  const handleGifClick = (gif: IGif, e: React.SyntheticEvent<HTMLElement, Event>) => {
    // Prevent navigation
    e.preventDefault()
    // Handle the GIF selection
    if (onGifSelected) {
      onGifSelected(gif.images.original.url)
    }
    closeGiphyDialog()
  }

  return (
    <Box display="none">
      <SearchContextManager
        apiKey={giphyApiKey}
        shouldDefaultToTrending
        options={{ lang: language }}>
        <CustomDialog maxWidth="sm" dialogKey={giphyDialogKey}>
          <GiphySearchContent handleGifClick={handleGifClick} id={id} />
          <PoweredByGiphyIcon />
        </CustomDialog>
      </SearchContextManager>
    </Box>
  )
}

export default GiphySearchDialog
